export const getAdminApi = (defaultSeasons: true | undefined) => {
  if (defaultSeasons !== undefined) {
    return "admin/";
  }
  return "";
};



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/seasonsPage/utils/getAdminApi/getAdminApi.ts